module.exports = __webpack_public_path__ + "img/DSC_2926-xl.f9ce8273.png";